import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { OnboardingBrand } from '../ai-exam-onboarding-progress.util';
import { AIExamOnboardingShellComponent } from '../AI-exam-onboarding-shell/AI-exam-onboarding-shell.component';

/** Pilule de contexte affichée sur l'écran de lancement. */
export interface LaunchContextPill {
    labelKey: string;
    value: string;
}

/**
 * Écran final de lancement (maquette 7) avec récap contexte et CTA.
 */
@Component({
    selector: 'lib-ai-exam-onboarding-launch',
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        TranslateModule,
        AIExamOnboardingShellComponent,
    ],
    templateUrl: './AI-exam-onboarding-launch.component.html',
    styleUrls: ['./AI-exam-onboarding-launch.component.scss'],
})
export class AIExamOnboardingLaunchComponent {
    @Input() brand: OnboardingBrand = 'flashlevel';
    @Input() firstName = '';
    @Input() lastName = '';
    @Input() contextPills: LaunchContextPill[] = [];
    @Input() loading = false;
    @Input() testCreationError = false;

    @Output() start = new EventEmitter<void>();

    get greetingName(): string {
        return this.firstName
    }

    get ctaKey(): string {
        if (this.testCreationError) {
            return 'ai-exam-onboarding.launch.retry';
        }
        return this.brand === 'flashlevel'
            ? 'ai-exam-onboarding.launch.cta-flashlevel'
            : 'ai-exam-onboarding.launch.cta-lilate';
    }
}
